import React, { PropsWithChildren } from 'react';
import { ContainerProps, StyledGridContainer } from './styles';

export const GridContainer: React.FC<PropsWithChildren<ContainerProps>> = ({
  children,
  gap
}) => {
  return <StyledGridContainer gap={gap}>{children}</StyledGridContainer>;
};
